import { Component, OnInit, EventEmitter, Output, Input, AfterContentInit } from '@angular/core';
import { DataService } from '../../services/data.service';
import DataSource from 'devextreme/data/data_source';

import {
	DxSelectBoxModule,
	DxTextAreaModule,
	DxDateBoxModule,
  DxFormModule,
  DxFormComponent
} from 'devextreme-angular';


@Component({
  selector: 'app-registri-rifiuti-grid',
  templateUrl: './registri-rifiuti-grid.component.html',
  styleUrls: ['./registri-rifiuti-grid.component.scss'],
  providers: [DataService]
})
export class RegistriRifiutiGridComponent implements OnInit {
  gridDataSource: DataSource;
  selectedRows: Array<any> = [];
  @Input() call;
  @Output() onChange: EventEmitter<any> = new EventEmitter();
  //state
  @Input() state:Boolean=false;
  selectionChanged(): void {
   // this.onChange.emit(this.selectedRows[0]);
}
  constructor(private dataService: DataService) { 
    
  }/*
  clikkato(event:any){
    alert("clikkato");
  }
  Aggiorna(){
    alert("Aggiorno");
  }
  ngAfterContentInit(){
console.log(this.call);
    if (this.call==1){
      
      this.dataService.getData2().subscribe(data => {
        console.log(data);
        this.gridDataSource = new DataSource({ store: { type: 'array', data: data['items'] }});
        this.selectedRows = [data[0]];
      
      
      
    });
    }
    if (this.call==2)
      {
        this.dataService.getData3().subscribe(data => {
          console.log(data);
          this.gridDataSource = new DataSource({ store: { type: 'array', data: data['items'] }});
          this.selectedRows = [data[0]];
        
        
  
          
        
    });
    }

  }*/
  ngOnInit() {

   
  }
}
